module.exports = __webpack_public_path__ + "assets/img/hcpbt5.3ed0e9a1.png";